<template>
  <div class="technicInvoice">
    <vs-prompt :vs-title="'Fatura #' + this.value" vs-cancel-text="Vazgeç" vs-button-cancel="border" @vs-close="cancel" @vs-cancel="cancel" :vs-active.sync="visible" vs-accept-text="Kaydet" @vs-accept="submit" :vs-is-valid="validateForm">
      <vcl-table secondary="#ff9f43" v-if="loading"></vcl-table>
      <div class="vx-row ml-5 mr-5" v-if="!loading">
        <VuePerfectScrollbar class="scroll-area" :settings="settings">
          <div v-if="parasutId == 0">
            Satış emri muhasebeye iletildi, fatura kesilmesi bekleniyor!
          </div>
          <div v-if="parasutId > 0">
            <div class="flex items-center">
              <a style="font-weight: bolder" class="success" :href="'https://uygulama.parasut.com/348057/satislar/' + this.parasutId" target="_blank">
                <feather-icon icon="FileTextIcon"></feather-icon>
                <span class>Fatura görüntüle</span>
              </a>
            </div>
          </div>
          <div class v-if="parasutId < 0">
            <div class="mt-2">
              <div class="vx-col w-full">
                <vs-table noDataText="Tabloda Veri Yok" :data="selectedProducts">
                  <template slot="header">
                    <h5>
                      Fatura edilecek ürünleri ve teknik servis hizmet bedelini giriniz
                    </h5>
                    <vs-button size="small" type="filled" @click="openProductPopupFunc">Ürün Seç</vs-button>
                  </template>

                  <template slot="thead">
                    <vs-th style="width: 300px">Ürün / Hizmet</vs-th>
                    <vs-th>Birim Fiyat</vs-th>
                    <vs-th>Adet</vs-th>
                    <vs-th>Satış Fiyatı</vs-th>
                    <vs-th>İndirim Yüzdesi</vs-th>
                    <vs-th>Toplam</vs-th>
                    <vs-th>İşlem</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td hidden :data="data[indextr].productId">
                        {{ data[indextr].productId }}
                      </vs-td>

                      <vs-td :data="data[indextr].productName">
                        {{ data[indextr].productName }}
                      </vs-td>

                      <vs-td :data="data[indextr].price">{{ parseFloat(data[indextr].price).toFixed(2) + " ₺" }}</vs-td>
                      <vs-td :data="data[indextr].quantity">{{ data[indextr].quantity + " Adet" }}</vs-td>

                      <vs-td :data="data[indextr].sellPrice">{{ parseFloat(data[indextr].sellPrice).toFixed(2) + " ₺" }}</vs-td>

                      <vs-td :style="profit(data[indextr]) < 0 ? 'color:red;font-weight:bolder;' : ''">{{ beautifyProfit(data[indextr]) }}</vs-td>
                      <vs-td :data="data[indextr].quantity">{{ parseFloat(data[indextr].quantity * data[indextr].sellPrice).toFixed(2) + " ₺" }}</vs-td>
                      <vs-td>
                        <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="deleteRow(data[indextr])"></vs-button>
                      </vs-td>
                    </vs-tr>

                    <vs-tr v-if="data.length != 0">
                      <vs-td>
                        <hr />
                      </vs-td>
                      <vs-td>
                        <hr />
                      </vs-td>
                      <vs-td>
                        <hr />
                      </vs-td>
                      <vs-td>
                        <hr />
                      </vs-td>
                      <vs-td>
                        <hr />
                      </vs-td>
                      <vs-td>
                        <hr />
                      </vs-td>
                      <vs-td>
                        <hr />
                      </vs-td>
                    </vs-tr>

                    <vs-tr v-if="data.length != 0">
                      <vs-th>Genel Toplam</vs-th>
                      <vs-th colspan="3"></vs-th>
                      <vs-th>{{ beautifyDiscount }}</vs-th>
                      <vs-th>{{ parseFloat(grandTotal.priceDiscounted).toFixed(2) + " ₺" }}</vs-th>
                      <vs-th colspan="1"></vs-th>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <ag-grid-table :openProducts="openProductPopup" v-if="openProductPopup" v-model="selectedProducts" @hideProducts="closeProductPopup"></ag-grid-table>
          </div>
        </VuePerfectScrollbar>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import { VclTable } from "vue-content-loading";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import agGridTable from "../sales/addComponents/agGridTable.vue";

export default {
  components: {
    VclTable,
    VuePerfectScrollbar,
    agGridTable,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      visible: true,
      parasutId: -1,
      loading: true,
      openProductPopup: false,
      selectedProducts: [
        {
          productId: 1391,
          productName: "Teknik Servis Hizmet Bedeli",
          productDescription: null,
          productCategoryID: 7,
          productCategory: "Hizmet Bedeli",
          stock: 999,
          wareHouseId: 10,
          wareHouse: null,
          price: 500,
          parasutId: 27627282,
          forceBarcode: false,
          quantity: 1,
          sellPrice: 500,
        },
      ],
      currentItem: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
      grandTotal: {
        sumUnitPrice: 0,
        sumSalePrice: 0,
        sumquantity: 0,
        price: 0,
        discountPercent: 0,
      },
      previousNotes: "",
    };
  },
  created() {
    this.getData();
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    beautifyDiscount() {
      if (this.grandTotal.discountPercent < 0.01 && this.grandTotal.discountPercent > -0.01) {
        if (this.grandTotal.discountPercent < 0.000000001 && this.grandTotal.discountPercent > -0.000000001) return "-";
        else return "- / " + (this.grandTotal.priceDiscounted - this.grandTotal.sumUnitPrice).toFixed(2) + " " + ((this.tempCurrency && this.tempCurrency.logo) || "₺");
      }
      return "% " + (this.grandTotal.discountPercent * 100).toFixed(2) + " / " + (this.grandTotal.priceDiscounted - this.grandTotal.sumUnitPrice).toFixed(2) + " " + ((this.tempCurrency && this.tempCurrency.logo) || "₺");
    },
  },
  methods: {
    openProductPopupFunc() {
      this.openProductPopup = true;
    },
    getData: async function() {
      if (!(this.value > 0)) {
        this.$vs.notify({
          title: "Hata",
          text: "Servis bilgisi alınamadı!",
          color: "primary",
        });
        this.loading = false;
        return;
      }
      let a = await repository
        .postEntity("technic/getOrders", { id: this.value })
        .then((r) => r.list)
        .then((r) => r[0]);
      if (typeof a == "object") {
        a = repository.convertToJSON(a, "serviceNote");
        if (typeof a.serviceNote != "object" || !a.serviceNote.customer || !a.serviceNote.technic) {
          a.serviceNote = { customer: "", technic: [] };
        }
        this.beautifyServiceNotes(a, "serviceNote");
        this.currentItem = a;
      }
      let c = await repository.postEntity("technic/createInvoice?orderId=" + this.value + "&create=false");
      this.parasutId = -1;
      if (c && c.isSuccessful) {
        this.parasutId = c.returnID;
      }
      this.calculate();
      this.loading = false;
    },
    beautifyServiceNotes(currentItem, prop) {
      this.previousNotes = "Müşteri Şikayeti: " + currentItem[prop].customer + "\r\n\r\nTeknik Servis Notu:\r\n";
      if (Array.isArray(currentItem[prop].technic)) {
        let ctr = 1;
        for (var i = 0; i < currentItem[prop].technic.length; i++) {
          if (currentItem[prop].technic[i].trim().length > 0) {
            this.previousNotes += ctr + ") " + currentItem[prop].technic[i] + "\r\n";
            ctr++;
          }
        }
      } else {
        if (currentItem[prop].technic.trim().length > 0) this.previousNotes += ": 1. " + currentItem[prop].technic + "\r\n";
      }
    },
    deleteRow: function(d) {
      this.selectedProducts = this.selectedProducts.filter((val) => d.productId != val.productId || d.wareHouseId != val.wareHouseId);
      this.calculate();
    },
    profit: function(e) {
      let a = (e.sellPrice - e.price) / e.price;
      if (a < 0.01 && a > -0.01) return "-";
      a = a * 100;
      return a;
    },
    beautifyProfit: function(e) {
      let r = this.profit(e);
      if (typeof r == "number") {
        return "%" + parseFloat(r).toFixed(2);
      }
      return "-";
    },
    calculate: function() {
      this.grandTotal.sumUnitPrice = 0;
      this.grandTotal.sumquantity = 0;
      this.grandTotal.priceDiscounted = 0;
      this.grandTotal.discountPercent = 0;
      let sumSalePrice = 0;
      //kdv yüzdesi
      let a = 0;

      if (this.selectedProducts.length > 0) {
        for (let i = 0; i < this.selectedProducts.length; i++) {
          //toplam birim fiyat
          this.grandTotal.sumUnitPrice = this.selectedProducts[i].price * this.selectedProducts[i].quantity + this.grandTotal.sumUnitPrice;
          //toplam adet
          this.grandTotal.sumquantity = this.grandTotal.sumquantity + parseInt(this.selectedProducts[i].quantity);
          sumSalePrice = this.selectedProducts[i].sellPrice * this.selectedProducts[i].quantity + sumSalePrice;

          //toplam indirmli fiyat
          this.grandTotal.priceDiscounted = (this.selectedProducts[i].sellPrice + this.selectedProducts[i].sellPrice * a) * parseInt(this.selectedProducts[i].quantity) + this.grandTotal.priceDiscounted;
          //toplam indirim yüzdesi
          this.grandTotal.discountPercent = (sumSalePrice - this.grandTotal.sumUnitPrice) / this.grandTotal.sumUnitPrice;
          if (isNaN(this.grandTotal.discountPercent)) this.grandTotal.discountPercent = 0;
        }
      }

    },
    closeProductPopup(r, data) {
      if (r == 1) {
        this.selectedProducts = [];
        this.selectedProducts = [].concat(data);
      }
      this.calculate();
      this.openProductPopup = false;
    },
    cancel() {
      this.visible = true;
      this.$emit("updateCompleted", 0);
    },
    async submit() {
      this.visible = true;
      if (this.parasutId >= 0) return;
      let control = false;
      for (let i = 0; i < this.selectedProducts.length; i++) {
        if (!this.selectedProducts[i].id) this.selectedProducts[i].id = -1;

        if (!this.selectedProducts[i].wareHouseId) this.selectedProducts[i].wareHouseId = -1;

        if (!this.selectedProducts[i].price || this.selectedProducts[i].price <= 0) this.selectedProducts[i].price = this.selectedProducts[i].sellPrice;

        this.selectedProducts[i].price = this.selectedProducts[i].price / 1.20;
        this.selectedProducts[i].sellPrice = this.selectedProducts[i].sellPrice / 1.20;
        this.selectedProducts[i].priceDiscounted = this.selectedProducts[i].sellPrice;
        this.selectedProducts[i].productAmount = this.selectedProducts[i].quantity;
        this.selectedProducts[i].priceId= 3 ;

      }
   
      let first = await repository.postEntity("technic/createInvoice?orderId=" + this.value + "&create=true");
      if (!first) {
        control = false;
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "İşlem tamamlanamadı. Bilinmeyen Hata!",
        });
      } else {
        if (first.isSuccessful) {
          control = this.$validator.validateAll() && true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: `${first.exceptionMessage}`,
          });
        }
      }
      if (!control) return;
      //mesajı Kaydet
      let postModel = {
        saleOrderId: 0,
        customerId: this.currentItem.customerId,
        orderNote: "Servis Id: " + this.value + "\r\n" + this.previousNotes,
        saleOrderType: 5,
        createdDate: navigator.getDate(new Date()),
        validUntil: navigator.getDate(new Date(new Date() + 7 * 24 * 60 * 60 * 1000)),
        taxIncluded: true,
        currencyType: 3,
        paymentType: 3,
        deliveryType: 1,
        deliveryAddress: this.currentItem.customerAddress,
        OrderLines: this.selectedProducts,
        price: this.grandTotal.sumUnitPrice,
        priceDiscounted: this.grandTotal.priceDiscounted,
        discount: this.grandTotal.priceDiscounted,
        discountPercent: this.grandTotal.discountPercent,
        lineType: 1,
        technicId: this.value,
        isFullInvoice: true,
      };

      let r = await repository.postEntity("Sale/createOrder", postModel);

      if (r && r.isSuccessful) {
        postModel = {
          currentUser: 0,
          orderId: r.returnID,
          assignedTo: 0,
          status: 8,
          serviceNote: "",
        };
        r = await repository.postEntity("Sale/assignUserToOrder", postModel);
        if (r.isSuccessful) {
          this.$vs.notify({
            color: "success",
            title: `Başarılı! `,
            text: "Ekleme işlemi tamamlandı.",
          });
        } else if (r.hasExceptionError) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: `${r.exceptionMessage}`,
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "İşlem tamamlanamadı. Bilinmeyen Hata!",
          });
        }
      } else if (r.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: `${r.exceptionMessage}`,
        });
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "İşlem tamamlanamadı. Bilinmeyen Hata!",
        });
      }
      this.$emit("updateCompleted", this.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.technicInvoice {
  @media screen and (max-width: 600px) {
    .con-vs-dialog .vs-dialog {
      width: 90%;
    }
    .scroll-area {
      position: relative;
      margin: auto;
      height: 80vh;
    }
  }
  @media screen and (max-width: 992px) {
    .con-vs-dialog .vs-dialog {
      min-width: 90%;
      width: 90%;
    }
    .scroll-area {
      position: relative;
      margin: auto;
      height: 80vh;
    }
  }
}
</style>
